import { render, staticRenderFns } from "./CabinetRentalDetails.vue?vue&type=template&id=202360e2&"
import script from "./CabinetRentalDetails.vue?vue&type=script&lang=js&"
export * from "./CabinetRentalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports